// extracted by mini-css-extract-plugin
export var container = "_go-0";
export var outlet = "_go-1";
export var outletEnter = "_go-2";
export var outletEnterActive = "_go-3";
export var outletExit = "_go-4";
export var outletExitActive = "_go-5";